import {FLOATING_TOOL_MOVED, APPTOOLBAR_RESET_APP_STATE, MULTIBED_RESET_APP_STATE} from "../lib/types";

const initialState = {
    x: 0,
    y: 0
};

export default (state = initialState, action) => {
    /* discriminate the action type */
    switch (action.type) {
        case FLOATING_TOOL_MOVED:
            return {
                ...state,
                x: action.payload.x,
                y: action.payload.y
            };

        case MULTIBED_RESET_APP_STATE:
        case APPTOOLBAR_RESET_APP_STATE:
            return initialState;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/floating-tool-reducer.js